/**
 * @voltxampere/ui — Zener Diode (Zener)
 *
 * Standard diode triangle with a "Z-shaped" cathode bar — the bent
 * line at x=24 indicates the breakdown-region behaviour distinct
 * from the regular diode's straight bar.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const zener = {
    id: "zener",
    nameTr: "Zener",
    nameEn: "Zener Diode",
    shortcut: "Z",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "A", polarity: "in" },
        { x: 40, y: 13, label: "K", polarity: "out" },
    ],
    defaultLabel: "D",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="13" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="13,6 24,13 13,20" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<path d="M 21 6 L 24 6 L 24 20 L 27 20" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="24" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=zener.js.map